import { ConfigurationType } from '@server/parser';
import { DataTableId } from '../../components/common/table/utils';

export enum DocumentationTabTypes {
  RECORD_TYPES = 'Record Types',
  SF_AUTOMATIONS = 'Salesforce Automations',
  APEX = 'Apex',
  FIELDS = 'Fields',
  VALIDATION_RULES = 'Validation Rules',
  SWEEP_AUTOMATIONS = 'Sweep Automations',
  PLAYBOOK_ALERTS = 'Alerts',
  MATCHING_DEDUPE = 'Dedupe & Matching',
  ASSIGNMENTS = 'Assignments',
  SCHEDULED_ASSIGNMENTS = 'Scheduled Assignments',
  CPQ_DATA = 'CPQ Configuration',
  CARDS_LIST = 'elements', //main view
  LAYOUTS = 'Layouts',
  RELATED_OBJECTS = 'Related objects',
  OTHER = 'Other',
}

export const SWEEP_ELEMENTS_TAB_TYPES = [
  DocumentationTabTypes.MATCHING_DEDUPE,
  DocumentationTabTypes.PLAYBOOK_ALERTS,
  DocumentationTabTypes.SWEEP_AUTOMATIONS,
  DocumentationTabTypes.SCHEDULED_ASSIGNMENTS,
  DocumentationTabTypes.ASSIGNMENTS,
];

export const ConfigurationTypeToDocumentationTabType = {
  [ConfigurationType.validationRules]: DocumentationTabTypes.VALIDATION_RULES,
  [ConfigurationType.apexTriggers]: DocumentationTabTypes.APEX,
  [ConfigurationType.apexClasses]: DocumentationTabTypes.APEX,
  [ConfigurationType.approvalProcesses]: DocumentationTabTypes.SF_AUTOMATIONS,
  [ConfigurationType.workflowRules]: DocumentationTabTypes.SF_AUTOMATIONS,
  [ConfigurationType.processBuilderFlows]: DocumentationTabTypes.SF_AUTOMATIONS,
  [ConfigurationType.layouts]: DocumentationTabTypes.LAYOUTS,
  [ConfigurationType.flows]: DocumentationTabTypes.SF_AUTOMATIONS,
  [ConfigurationType.recordTypes]: DocumentationTabTypes.RECORD_TYPES,
  [ConfigurationType.fields]: DocumentationTabTypes.FIELDS,
  [ConfigurationType.sweepAssignment]: DocumentationTabTypes.ASSIGNMENTS,
  [ConfigurationType.sweepAlert]: DocumentationTabTypes.PLAYBOOK_ALERTS,
  [ConfigurationType.sweepAutomation]: DocumentationTabTypes.SWEEP_AUTOMATIONS,
  [ConfigurationType.sweepScheduledAssignment]: DocumentationTabTypes.SCHEDULED_ASSIGNMENTS,
  [ConfigurationType.sweepDedupe]: DocumentationTabTypes.MATCHING_DEDUPE,
  [ConfigurationType.sweepMatching]: DocumentationTabTypes.MATCHING_DEDUPE,
};

export const DocumentationTabToTableId: { [key in DocumentationTabTypes]: DataTableId } = {
  [DocumentationTabTypes.FIELDS]: DataTableId.DocumentationExpandedFieldsTable,
  [DocumentationTabTypes.RECORD_TYPES]: DataTableId.DocumentationExpandedRecordTypesTable,
  [DocumentationTabTypes.SF_AUTOMATIONS]: DataTableId.DocumentationExpandedAutomationsTable,
  [DocumentationTabTypes.APEX]: DataTableId.DocumentationExpandedApexTable,
  [DocumentationTabTypes.VALIDATION_RULES]: DataTableId.DocumentationExpandedValidationRulesTable,
  [DocumentationTabTypes.SWEEP_AUTOMATIONS]: DataTableId.DocumentationExpandedSweepAutomationsTable,
  [DocumentationTabTypes.PLAYBOOK_ALERTS]: DataTableId.DocumentationExpandedAlertsTable,
  [DocumentationTabTypes.MATCHING_DEDUPE]: DataTableId.DocumentationExpandedDedupeTable,
  [DocumentationTabTypes.ASSIGNMENTS]: DataTableId.DocumentationExpandedAssignmentsTable,
  [DocumentationTabTypes.SCHEDULED_ASSIGNMENTS]:
    DataTableId.DocumentationExpandedScheduledAssignmentsTable,
  [DocumentationTabTypes.CPQ_DATA]: DataTableId.DocumentationExpandedCpqDataTable,
  [DocumentationTabTypes.LAYOUTS]: DataTableId.DocumentationExpandedLayoutsTable,
  [DocumentationTabTypes.RELATED_OBJECTS]: DataTableId.DocumentationExpandedRelatedObjectsTable,
  [DocumentationTabTypes.CARDS_LIST]: DataTableId.DocumentationExpandedCardsListTable,
  [DocumentationTabTypes.OTHER]: DataTableId.DocumentationExpandedOtherTable,
};
